import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const jobArrangementRecordApi = {
    //查詢當前生效的推廣
    "getCurrTimeRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}jobrecord/getCurrTimeRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {}
        }
    },
    //查詢分類別的推廣
    "queryRecordListWithType": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}jobrecord/queryRecordListWithType`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {}
        }
    },
    //條件查詢
    "queryRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}jobrecord/queryRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                jatype: null  //類別
            }
        }
    },
    //刪除推廣
    "delRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}jobrecord/delRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null
            }
        }
    },
    //添加推廣
    "insertRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}jobrecord/insertRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo1: null,  //描述
                addinfo2: null,  //视频链接
                addinfo3: null,  //视频文件路径
                addinfo5: null,  //封面图片路径
                companycode: null,  //公司代码
                district1: null,  //地区代码
                jatype: null,  //类别
                jenddate: null,  //有效期截止日期
                jobtitle: null,  //标题
                jstartdate: null,  //有效期开始日期
                orderactionremark: null,  //3dshop链接
                ordermember: null,  //展台链接
                ordermembergroup: null,  //名片链接
                orderref: null,  //tiktok链接
                orderrefno: null,  //小红书链接
                orderreplyremark: null,  //youtube视频链接
                ordertorefno: null,  //facebook链接
                ownerfinished: -1,  //状态 -1正常 0隐藏
                shipmentaddress: null,  //英文标题
                shipmentaddresscn: null,  //英文描述
                updatedid: null,  //类别id
            }
        }
    },
    //修改推廣
    "updateRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}jobrecord/updateRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                addinfo1: null,  //描述
                addinfo2: null,  //视频链接
                addinfo3: null,  //视频文件路径
                addinfo5: null,  //封面图片路径
                companycode: null,  //公司代码
                district1: null,  //地区代码
                jatype: null,  //类别
                jenddate: null,  //有效期截止日期
                jobtitle: null,  //标题
                jstartdate: null,  //有效期开始日期
                orderactionremark: null,  //3dshop链接
                ordermember: null,  //展台链接
                ordermembergroup: null,  //名片链接
                orderref: null,  //tiktok链接
                orderrefno: null,  //小红书链接
                orderreplyremark: null,  //youtube视频链接
                ordertorefno: null,  //facebook链接
                ownerfinished: -1,  //状态 -1正常 0隐藏
                shipmentaddress: null,  //英文标题
                shipmentaddresscn: null,  //英文描述
                updatedid: null,  //类别id
            }
        }
    },
}

export default jobArrangementRecordApi